export class IndicadoresEconomicos {
    constructor() {
        this.apiBase = 'https://mindicador.cl/api';
    }

    async traerIndicadores() {
        try {
            const response = await fetch(this.apiBase);
            const data = await response.json();

            if (data.uf && data.uf.valor) {
                const uf = this.formatoMoneda(data.uf.valor);
                const el = document.getElementById('indicator-value-uf');
                if (el) el.textContent = uf + ' CLP';
            }

            if (data.utm && data.utm.valor) {
                const utm = this.formatoMoneda(data.utm.valor);
                const el = document.getElementById('indicator-value-utm');
                if (el) el.textContent = utm + ' CLP';
            }
        } catch (error) {
            console.error('Error al cargar indicadores económicos:', error);
        }
    }

    formatoMoneda(valor) {
        return new Intl.NumberFormat('es-CL', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(valor);
    }

    init() {
        this.traerIndicadores();
    }
}

// Si usas require (no import/export), entonces:
// module.exports = { IndicadoresEconomicos };
